__turbopack_context__.v({
  "className": "roboto_serif_8946962f-module__BVFmTq__className",
});
